//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Helper Imports

import { DataProvider } from '../helpers/data-provider'

//#endregion

//#region Model Imports

import { Enums } from '../models/common/enums'
import { OpDataTypeInGroup } from '../models/core/op-data-type-in-group'

//#endregion

export class DataTypeGroupComponent {

    public static getDataTypeInGroupByModule(
        dataProvider: DataProvider,
        dataTypeGroupCategory: Enums.SimaxDataTypeGroupCategory,
        moduleName: Enums.SimaxModuleName,
        groupReferenceType?: Enums.ReferenceType,
        groupReferenceValue?: number
    ): JQueryPromise<OpDataTypeInGroup[]> {

        let groupName: string = null

        switch (dataTypeGroupCategory) {
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ALARM_DEF_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ALARM_DEF_REF_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ALARM_DEF_PANEL_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ASSIGNED_LOCATION_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__CONTENT_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEF_REF_PARAMS: // TODO: This group should be replaced with WEBSIMAX__MODULE_NAME__ALARM_DEF_REF_PARAMS
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEVICE_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_DISPLAY:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_EDIT:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GROUP_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__IMPORT_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__INSTALLED_DEVICES_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__LOCATION_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__LOCATION_PANEL_PARAMS_TO_DISPLAY:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__LOCATION_PANEL_PARAMS_TO_EDIT:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__LOCATION_PARAMS_REQUIRED:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__MEASUREMENTS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__METER_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__OPERATOR_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_DISPLAY:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_EDIT:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PARAMS_REQUIRED:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__POPUP_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PREVIEW_PANEL_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__TASK_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__TRANSACTIONS_DEFAULT_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__TRANSACTIONS_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__UNINSTALLED_DEVICES_GRID_PARAMS:
            case Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__COPY_SKIP_PARAMS:
                {
                    if (moduleName != Enums.SimaxModuleName.Unknown) {
                        groupName = Enums.SimaxDataTypeGroupCategory[dataTypeGroupCategory].replace("_MODULE_NAME_", Enums.SimaxModuleName[moduleName].toUpperCase())
                    } else {
                        console.log("Cannot find module name for reference type: " + Enums.ReferenceType[groupReferenceType])
                    }

                    break
                }
            default: {
                console.log("Unsupported data type group category: " + Enums.SimaxDataTypeGroupCategory[dataTypeGroupCategory])

                break
            }
        }

        return dataProvider.DataTypeGroup.getDataTypeInGroup(groupName, groupReferenceType, groupReferenceValue)
    }
}
